import {OrdersApi, AgencyApi, AgencyTalentsApi, OrganizationsApi, TalentsApi} from './index';
export const API = {
  Agencies: new AgencyApi(),
  Orders: new OrdersApi(),
  AgencyTalents: new AgencyTalentsApi(),
  Organizations: new OrganizationsApi(),
  Talents: new TalentsApi(),
};
